import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=2c1ae99b&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=2c1ae99b&prod&scoped=true&lang=css&"
import style1 from "./widget.vue?vue&type=style&index=1&id=2c1ae99b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ae99b",
  null
  
)

export default component.exports